"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var datapoints_1 = require("./datapoints");
var moveMailListRowsHelper_1 = require("./helpers/moveMailListRowsHelper");
var moveItemsService_1 = require("../services/moveItemsService");
var deleteItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/deleteItemsStoreUpdate");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_store_1 = require("owa-mail-store");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * The action worker which handles moving conversations.
 * @param conversationIds - the conversations that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the conversations are moving from
 */
exports.default = legacy_1.action('moveItems', datapoints_1.default.moveItemsDatapoint)(function moveItems(rowKeys, destinationFolderId, originalTableView, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, moveMailListRowsHelper_1.default(rowKeys, destinationFolderId, originalTableView, moveItemsInternal, actionSource)];
        });
    });
});
/**
 * The move items internal method
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
function moveItemsInternal(rowKeys, destinationFolderId, originalTableView, sourceFolderId) {
    var itemIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, originalTableView.id);
    var itemContexts = itemIdStrings.map(function (itemIdValue) {
        var item = owa_mail_store_1.mailStore.items.get(itemIdValue);
        var isReadValue;
        if (owa_mail_list_store_1.isItemOfMessageType(item)) {
            isReadValue = item.IsRead;
        }
        else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
        };
    });
    // Dispatch action to update the store state
    deleteItemsStoreUpdate_1.default(itemContexts, sourceFolderId);
    // Make service request
    return moveItemsService_1.default(itemIdStrings, destinationFolderId, sourceFolderId)
        .then(function (moveItemResponse) {
        if (moveItemResponse.ResponseMessages) {
            addMovedItemsToUndoStack(moveItemResponse.ResponseMessages.Items, destinationFolderId, sourceFolderId);
        }
    })
        .catch();
}
function addMovedItemsToUndoStack(responseItems, destinationFolderId, sourceFolderId) {
    var movedItemIds = [];
    for (var _i = 0, responseItems_1 = responseItems; _i < responseItems_1.length; _i++) {
        var responseItem = responseItems_1[_i];
        if (responseItem.ResponseClass == 'Success') {
            movedItemIds.push(responseItem.Items[0].ItemId.Id);
        }
    }
    if (movedItemIds.length > 0) {
        undoActions.addActionToUndoStack(function () {
            // Reverse source folder id and destination folder id for undo
            return moveItemsService_1.default(movedItemIds, sourceFolderId, destinationFolderId);
        });
    }
}
//# sourceMappingURL=moveItems.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/moveItems.js
// module id = 5601
// module chunks = 62